import { css } from "styled-components";

export const smallSizeStyle = css`
  height: 30px;
  padding: 0 var(--gap-3);
  gap: var(--gap-2);
  font-size: var(--font-size-small);
  line-height: var(--line-height-small);

  svg {
    height: 16px;
    width: auto;
  }
`;
